import { TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  CheckboxCell as CheckboxCellBase,
  SelectBox as SelectBoxBase,
} from '../../styles';

export const Wrapper = styled(TableRow)`
  z-index: 9 !important;
  transition: all 0.3s ease-in-out !important;

  &.Clickable {
    cursor: pointer;
  }
  &.isSelected {
    display: none;
  }
  td {
    /* background: transparent !important; */
  }
  .MuiTableCell-root {
    /* background: transparent !important; */
  }
`;

export const Cell = styled(TableCell)`
  background: transparent;
  border-right-color: ${(p) => p.theme.palette.grey[300]};
  border-right-width: 1px;
`;

export const SelectBox = styled(SelectBoxBase)``;

export const CheckboxCell = styled(CheckboxCellBase)``;
